import { render, staticRenderFns } from "./UnitDetailModal.vue?vue&type=template&id=792388c4&"
import script from "./UnitDetailModal.vue?vue&type=script&lang=js&"
export * from "./UnitDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports